import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { FaqPageRoutingModule } from './faq-routing.module';

import { FaqPage } from './faq.page';
import {ComponentsModule} from "../../shared/components/components.module";
import {LoyaltyProgramPageModule} from "../loyalty-program/loyalty-program.module";
import {TranslocoDirective, TranslocoPipe} from "@jsverse/transloco";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        FaqPageRoutingModule,
        ComponentsModule,
        LoyaltyProgramPageModule,
        TranslocoDirective,
        TranslocoPipe
    ],
  declarations: [FaqPage]
})
export class FaqPageModule {}
